export const WORDS = [
  '물고기',
  '바다',
  '꽃밭',
  '나비',
  '숲속',
  '하늘',
  '달빛',
  '별빛',
  '햇살',
  '바람',
  '새소리',
  '푸른색',
  '빨간색',
  '노란색',
  '하얀색',
  '검은색',
  '작은새',
  '큰돌',
  '작은구름',
  '길가',
  '맑은물',
  '산길',
  '바위산',
  '비바람',
  '바다풍경',
  '산풍경',
  '해변',
  '무지개',
  '푸른하늘',
  '까만밤',
];

export const levelList = [
  { level: '1단계', count: '3개', timeLimit: '6초' },
  { level: '2단계', count: '5개', timeLimit: '6초' },
  { level: '3단계', count: '6개', timeLimit: '5초' },
  { level: '4단계', count: '7개', timeLimit: '5초' },
  { level: '5단계', count: '8개', timeLimit: '5초' },
];
